/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(18);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Action = function () {
	  function Action() {
	    // nothing
	
	    _classCallCheck(this, Action);
	  }
	
	  _createClass(Action, [{
	    key: 'reset',
	    value: function reset() {}
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      // need to be override.
	      if (!sprite) throw new Error('Action obejct is not valid.');
	    }
	  }]);
	
	  return Action;
	}();
	
	exports.default = Action;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = PIXI;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaBy = exports.AlphaTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlphaTo = exports.AlphaTo = function (_Action) {
	  _inherits(AlphaTo, _Action);
	
	  function AlphaTo(alpha, time) {
	    _classCallCheck(this, AlphaTo);
	
	    var _this = _possibleConstructorReturn(this, (AlphaTo.__proto__ || Object.getPrototypeOf(AlphaTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.alpha = alpha;
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(AlphaTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var alpha = sprite.alpha;
	      var speed = (this.alpha - alpha) / this._time * deltaMS;
	
	      sprite.alpha += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.alpha = this.alpha;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return AlphaTo;
	}(_Action4.default);
	
	var AlphaBy = exports.AlphaBy = function (_Action2) {
	  _inherits(AlphaBy, _Action2);
	
	  function AlphaBy(alpha, time) {
	    _classCallCheck(this, AlphaBy);
	
	    var _this2 = _possibleConstructorReturn(this, (AlphaBy.__proto__ || Object.getPrototypeOf(AlphaBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.alpha = alpha;
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(AlphaBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.talpha = null;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var alpha = sprite.alpha;
	      if (this.talpha === null) {
	        this.talpha = alpha + this.alpha;
	      }
	
	      var speed = (this.talpha - alpha) / this._time * deltaMS;
	
	      sprite.alpha += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.alpha = this.talpha;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return AlphaBy;
	}(_Action4.default);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Blink = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blink = exports.Blink = function (_Action) {
	  _inherits(Blink, _Action);
	
	  function Blink(count, time) {
	    _classCallCheck(this, Blink);
	
	    var _this = _possibleConstructorReturn(this, (Blink.__proto__ || Object.getPrototypeOf(Blink)).call(this));
	
	    _this.time = time * 1000;
	    _this.count = count;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(Blink, [{
	    key: 'reset',
	    value: function reset() {
	      this._count = this.count * 2;
	      this._gap = this.time / this._count; // 每次的时间
	      this._timer = 0;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      // const visible = sprite.visible;
	
	      if (this._timer <= 0) {
	        // toggle
	        sprite.visible = !sprite.visible;
	        this._timer = this._gap;
	        this._count--;
	      } else {
	        this._timer -= deltaMS;
	      }
	      // return true / false: ended / not end
	      if (this._count <= 0) {
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return Blink;
	}(_Action3.default);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CallFunc = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallFunc = exports.CallFunc = function (_Action) {
	  _inherits(CallFunc, _Action);
	
	  function CallFunc(func) {
	    _classCallCheck(this, CallFunc);
	
	    var _this = _possibleConstructorReturn(this, (CallFunc.__proto__ || Object.getPrototypeOf(CallFunc)).call(this));
	
	    _this.func = func || function () {};
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(CallFunc, [{
	    key: 'reset',
	    value: function reset() {}
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      this.func();
	      // 直接完之后结束
	      this.reset();
	      return true;
	    }
	  }]);

	  return CallFunc;
	}(_Action3.default);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DelayTime = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DelayTime = exports.DelayTime = function (_Action) {
	  _inherits(DelayTime, _Action);
	
	  function DelayTime(time) {
	    _classCallCheck(this, DelayTime);
	
	    var _this = _possibleConstructorReturn(this, (DelayTime.__proto__ || Object.getPrototypeOf(DelayTime)).call(this));
	
	    _this.time = time * 1000;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(DelayTime, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      // do nothing util time is out.
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return DelayTime;
	}(_Action3.default);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FadeOut = exports.FadeIn = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FadeIn = exports.FadeIn = function (_Action) {
	  _inherits(FadeIn, _Action);
	
	  function FadeIn(time) {
	    _classCallCheck(this, FadeIn);
	
	    var _this = _possibleConstructorReturn(this, (FadeIn.__proto__ || Object.getPrototypeOf(FadeIn)).call(this));
	
	    _this.time = time * 1000;
	    _this.alpha = 1;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(FadeIn, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var alpha = sprite.alpha;
	      var speed = (this.alpha - alpha) / this._time * deltaMS;
	
	      sprite.alpha += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.alpha = this.alpha;
	        this.reset(); // end reset action
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return FadeIn;
	}(_Action4.default);
	
	var FadeOut = exports.FadeOut = function (_Action2) {
	  _inherits(FadeOut, _Action2);
	
	  function FadeOut(time) {
	    _classCallCheck(this, FadeOut);
	
	    var _this2 = _possibleConstructorReturn(this, (FadeOut.__proto__ || Object.getPrototypeOf(FadeOut)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.alpha = 0;
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(FadeOut, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var alpha = sprite.alpha;
	      var speed = (this.alpha - alpha) / this._time * deltaMS;
	
	      sprite.alpha += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.alpha = this.alpha;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return FadeOut;
	}(_Action4.default);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pixi = __webpack_require__(2);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animation = function (_PIXI$utils$EventEmit) {
	  _inherits(Animation, _PIXI$utils$EventEmit);
	
	  function Animation(sprite, action) {
	    _classCallCheck(this, Animation);
	
	    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this));
	
	    _this._id = '_' + PIXI.utils.uid();
	    _this.sprite = sprite;
	    _this.action = action;
	
	    _this._started = false;
	    _this._ended = false;
	    _this._active = false;
	    return _this;
	  }
	
	  _createClass(Animation, [{
	    key: 'update',
	    value: function update(delta, deltaMS) {
	      if (!this._started) {
	        // start event
	        this.emit('start', deltaMS);
	        this._started = true;
	        this._active = true;
	      }
	
	      // do some update
	      this._ended = this.action.update(this.sprite, delta, deltaMS);
	
	      if (this._ended && this._active) {
	        // end event
	        this.emit('end', deltaMS);
	        this._active = false;
	      }
	    }
	  }, {
	    key: 'isEnded',
	    value: function isEnded() {
	      return this._ended;
	    }
	  }]);
	
	  return Animation;
	}(PIXI.utils.EventEmitter);
	
	var ActionManager = function () {
	  function ActionManager() {
	    _classCallCheck(this, ActionManager);
	
	    this.actions = {}; // the actions need to be done.
	    this._actionsToDelete = [];
	
	    this._last = 0;
	  }
	
	  _createClass(ActionManager, [{
	    key: 'update',
	    value: function update(delta) {
	      var deltaMS = void 0;
	      // calculate deltaMS
	      if (!delta && delta !== 0) {
	        // 如果没有指定 delta 时间
	        deltaMS = this._getDeltaMS();
	        delta = deltaMS / 1000;
	      } else {
	        // 如果指定时间，则直接使用
	        deltaMS = delta * 1000;
	      }
	      // 先循环执行动作.
	      /* eslint no-restricted-syntax: 1 */
	      for (var _id in this.actions) {
	        if (Object.prototype.hasOwnProperty.call(this.actions, _id)) {
	          var animation = this.actions[_id];
	          // 更新 action
	          animation.update(delta, deltaMS);
	          // if action is end, remove it.
	          if (animation.isEnded()) {
	            this._actionsToDelete.push(animation);
	          }
	        }
	      }
	
	      // 后删除已经结束，或者终止的动作
	      if (this._actionsToDelete.length) {
	        for (var i = 0; i < this._actionsToDelete.length; i += 1) {
	          this._remove(this._actionsToDelete[i]);
	        }
	        this._actionsToDelete.length = 0;
	      }
	    }
	
	    // run action
	
	  }, {
	    key: 'runAction',
	    value: function runAction(sprite, action) {
	      // add into actions to be done.
	      var animation = new Animation(sprite, action);
	      this.actions[animation._id] = animation;
	      return animation;
	    }
	
	    // cancel action
	
	  }, {
	    key: 'cancelAction',
	    value: function cancelAction(animation) {
	      // add into to be deleted.
	      this._actionsToDelete.push(animation);
	    }
	  }, {
	    key: '_remove',
	    value: function _remove(animation) {
	      delete this.actions[animation._id];
	    }
	
	    // 获得两个 frame 之间的时间，用于后续进行动作计算
	
	  }, {
	    key: '_getDeltaMS',
	    value: function _getDeltaMS() {
	      if (this._last === 0) this._last = Date.now();
	      var now = Date.now();
	      var deltaMS = now - this._last;
	      this._last = now;
	      return deltaMS;
	    }
	  }]);
	
	  return ActionManager;
	}();
	
	exports.default = ActionManager;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MoveBy = exports.MoveTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoveTo = exports.MoveTo = function (_Action) {
	  _inherits(MoveTo, _Action);
	
	  function MoveTo(x, y, time) {
	    _classCallCheck(this, MoveTo);
	
	    var _this = _possibleConstructorReturn(this, (MoveTo.__proto__ || Object.getPrototypeOf(MoveTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.x = x;
	    _this.y = y;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(MoveTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      // 最终的动画逻辑
	      var pos = sprite.position;
	      var speedX = (this.x - pos.x) / this._time * deltaMS;
	      var speedY = (this.y - pos.y) / this._time * deltaMS;
	
	      sprite.x += speedX;
	      sprite.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.x = this.x;
	        sprite.y = this.y;
	
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return MoveTo;
	}(_Action4.default);
	
	var MoveBy = exports.MoveBy = function (_Action2) {
	  _inherits(MoveBy, _Action2);
	
	  function MoveBy(x, y, time) {
	    _classCallCheck(this, MoveBy);
	
	    var _this2 = _possibleConstructorReturn(this, (MoveBy.__proto__ || Object.getPrototypeOf(MoveBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.x = x;
	    _this2.y = y;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(MoveBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.tx = null; // target x
	      this.ty = null; // target y
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var pos = sprite.position;
	      if (this.tx === null || this.ty === null) {
	        this.tx = pos.x + this.x;
	        this.ty = pos.y + this.y;
	      }
	
	      var speedX = (this.tx - pos.x) / this._time * deltaMS;
	      var speedY = (this.ty - pos.y) / this._time * deltaMS;
	
	      sprite.x += speedX;
	      sprite.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.x = this.tx;
	        sprite.y = this.ty;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return MoveBy;
	}(_Action4.default);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PivotBy = exports.PivotTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PivotTo = exports.PivotTo = function (_Action) {
	  _inherits(PivotTo, _Action);
	
	  function PivotTo(x, y, time) {
	    _classCallCheck(this, PivotTo);
	
	    var _this = _possibleConstructorReturn(this, (PivotTo.__proto__ || Object.getPrototypeOf(PivotTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.x = x;
	    _this.y = y;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(PivotTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var pivot = sprite.pivot;
	      var speedX = (this.x - pivot.x) / this._time * deltaMS;
	      var speedY = (this.y - pivot.y) / this._time * deltaMS;
	
	      sprite.pivot.x += speedX;
	      sprite.pivot.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.pivot.x = this.x;
	        sprite.pivot.y = this.y;
	
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return PivotTo;
	}(_Action4.default);
	
	var PivotBy = exports.PivotBy = function (_Action2) {
	  _inherits(PivotBy, _Action2);
	
	  function PivotBy(x, y, time) {
	    _classCallCheck(this, PivotBy);
	
	    var _this2 = _possibleConstructorReturn(this, (PivotBy.__proto__ || Object.getPrototypeOf(PivotBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.x = x;
	    _this2.y = y;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(PivotBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.tx = null; // target x
	      this.ty = null; // target y
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var pivot = sprite.pivot;
	      if (this.tx === null || this.ty === null) {
	        this.tx = pivot.x + this.x;
	        this.ty = pivot.y + this.y;
	      }
	
	      var speedX = (this.tx - pivot.x) / this._time * deltaMS;
	      var speedY = (this.ty - pivot.y) / this._time * deltaMS;
	
	      sprite.pivot.x += speedX;
	      sprite.pivot.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.pivot.x = this.tx;
	        sprite.pivot.y = this.ty;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return PivotBy;
	}(_Action4.default);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Repeat = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Repeat = exports.Repeat = function (_Action) {
	  _inherits(Repeat, _Action);
	
	  function Repeat(action, count) {
	    _classCallCheck(this, Repeat);
	
	    var _this = _possibleConstructorReturn(this, (Repeat.__proto__ || Object.getPrototypeOf(Repeat)).call(this));
	
	    _this.action = action;
	    _this.count = count;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(Repeat, [{
	    key: 'reset',
	    value: function reset() {
	      this._count = this.count;
	      // 无效数字的时候，为无穷大
	      if (!this._count) this._count = Infinity;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var isEnd = this.action.update(sprite, delta, deltaMS);
	      if (isEnd) {
	        this.action.reset();
	        this._count = this._count - 1;
	      }
	      // 循环结束
	      if (this._count <= 0) {
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return Repeat;
	}(_Action3.default);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RotateBy = exports.RotateTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RotateTo = exports.RotateTo = function (_Action) {
	  _inherits(RotateTo, _Action);
	
	  function RotateTo(rotation, time) {
	    _classCallCheck(this, RotateTo);
	
	    var _this = _possibleConstructorReturn(this, (RotateTo.__proto__ || Object.getPrototypeOf(RotateTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.rotation = rotation;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(RotateTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var rotation = sprite.rotation;
	      var speed = (this.rotation - rotation) / this._time * deltaMS;
	
	      sprite.rotation += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.rotation = this.rotation;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return RotateTo;
	}(_Action4.default);
	
	var RotateBy = exports.RotateBy = function (_Action2) {
	  _inherits(RotateBy, _Action2);
	
	  function RotateBy(rotation, time) {
	    _classCallCheck(this, RotateBy);
	
	    var _this2 = _possibleConstructorReturn(this, (RotateBy.__proto__ || Object.getPrototypeOf(RotateBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.rotation = rotation;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(RotateBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.trotation = null; // target rotation
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var rotation = sprite.rotation;
	
	      if (this.trotation === null) {
	        this.trotation = rotation + this.rotation;
	      }
	      var speed = (this.trotation - rotation) / this._time * deltaMS;
	
	      sprite.rotation += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.rotation = this.trotation;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return RotateBy;
	}(_Action4.default);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScaleBy = exports.ScaleTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScaleTo = exports.ScaleTo = function (_Action) {
	  _inherits(ScaleTo, _Action);
	
	  function ScaleTo(scaleX, scaleY, time) {
	    _classCallCheck(this, ScaleTo);
	
	    var _this = _possibleConstructorReturn(this, (ScaleTo.__proto__ || Object.getPrototypeOf(ScaleTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.x = scaleX;
	    _this.y = scaleY;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(ScaleTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      // 最终的动画逻辑
	      var scale = sprite.scale;
	      var scaleX = (this.x - scale.x) / this._time * deltaMS;
	      var scaleY = (this.y - scale.y) / this._time * deltaMS;
	
	      sprite.scale.x += scaleX;
	      sprite.scale.y += scaleY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.scale.x = this.x;
	        sprite.scale.y = this.y;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return ScaleTo;
	}(_Action4.default);
	
	var ScaleBy = exports.ScaleBy = function (_Action2) {
	  _inherits(ScaleBy, _Action2);
	
	  function ScaleBy(scaleX, scaleY, time) {
	    _classCallCheck(this, ScaleBy);
	
	    var _this2 = _possibleConstructorReturn(this, (ScaleBy.__proto__ || Object.getPrototypeOf(ScaleBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.x = scaleX;
	    _this2.y = scaleY;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(ScaleBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.tx = null; // target scale x
	      this.ty = null; // target scale y
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var scale = sprite.scale;
	      if (this.tx === null || this.ty === null) {
	        this.tx = scale.x + this.x;
	        this.ty = scale.y + this.y;
	      }
	
	      var speedX = (this.tx - scale.x) / this._time * deltaMS;
	      var speedY = (this.ty - scale.y) / this._time * deltaMS;
	
	      sprite.scale.x += speedX;
	      sprite.scale.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.scale.x = this.tx;
	        sprite.scale.y = this.ty;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return ScaleBy;
	}(_Action4.default);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sequence = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sequence = exports.Sequence = function (_Action) {
	  _inherits(Sequence, _Action);
	
	  function Sequence(actions) {
	    _classCallCheck(this, Sequence);
	
	    var _this = _possibleConstructorReturn(this, (Sequence.__proto__ || Object.getPrototypeOf(Sequence)).call(this));
	
	    _this.actions = actions;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(Sequence, [{
	    key: 'reset',
	    value: function reset() {
	      this._index = 0;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      if (this._index >= this.actions.length) {
	        return true; // 所有 action 结束
	      }
	      var action = this.actions[this._index];
	
	      var isEnd = action.update(sprite, delta, deltaMS);
	      if (isEnd) {
	        action.reset();
	        this._index += 1;
	      }
	      return false;
	    }
	  }]);

	  return Sequence;
	}(_Action3.default);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SkewBy = exports.SkewTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkewTo = exports.SkewTo = function (_Action) {
	  _inherits(SkewTo, _Action);
	
	  function SkewTo(x, y, time) {
	    _classCallCheck(this, SkewTo);
	
	    var _this = _possibleConstructorReturn(this, (SkewTo.__proto__ || Object.getPrototypeOf(SkewTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.x = x;
	    _this.y = y;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(SkewTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var skew = sprite.skew;
	      var speedX = (this.x - skew.x) / this._time * deltaMS;
	      var speedY = (this.y - skew.y) / this._time * deltaMS;
	
	      sprite.skew.x += speedX;
	      sprite.skew.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.skew.x = this.x;
	        sprite.skew.y = this.y;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return SkewTo;
	}(_Action4.default);
	
	var SkewBy = exports.SkewBy = function (_Action2) {
	  _inherits(SkewBy, _Action2);
	
	  function SkewBy(x, y, time) {
	    _classCallCheck(this, SkewBy);
	
	    var _this2 = _possibleConstructorReturn(this, (SkewBy.__proto__ || Object.getPrototypeOf(SkewBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.x = x;
	    _this2.y = y;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(SkewBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.tx = null; // target x
	      this.ty = null; // target y
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var skew = sprite.skew;
	      if (this.tx === null || this.ty === null) {
	        this.tx = skew.x + this.x;
	        this.ty = skew.y + this.y;
	      }
	
	      var speedX = (this.tx - skew.x) / this._time * deltaMS;
	      var speedY = (this.ty - skew.y) / this._time * deltaMS;
	
	      sprite.skew.x += speedX;
	      sprite.skew.y += speedY;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.skew.x = this.tx;
	        sprite.skew.y = this.ty;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return SkewBy;
	}(_Action4.default);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Spawn = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action2 = __webpack_require__(1);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spawn = exports.Spawn = function (_Action) {
	  _inherits(Spawn, _Action);
	
	  function Spawn(actions) {
	    _classCallCheck(this, Spawn);
	
	    var _this = _possibleConstructorReturn(this, (Spawn.__proto__ || Object.getPrototypeOf(Spawn)).call(this));
	
	    _this.actions = actions;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(Spawn, [{
	    key: 'reset',
	    value: function reset() {}
	    // nothing
	
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      if (!this.actions || !this.actions.length) {
	        return true;
	      }
	      var result = true;
	      for (var i = this.actions.length - 1; i >= 0; i -= 1) {
	        var action = this.actions[i];
	
	        var isEnd = action.update(sprite, delta, deltaMS);
	        if (isEnd) {
	          action.reset();
	          this.actions.splice(i, 1);
	        } else {
	          result = false;
	        }
	      }
	      return result;
	    }
	  }]);

	  return Spawn;
	}(_Action3.default);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TintBy = exports.TintTo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Action3 = __webpack_require__(1);
	
	var _Action4 = _interopRequireDefault(_Action3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TintTo = exports.TintTo = function (_Action) {
	  _inherits(TintTo, _Action);
	
	  function TintTo(tint, time) {
	    _classCallCheck(this, TintTo);
	
	    var _this = _possibleConstructorReturn(this, (TintTo.__proto__ || Object.getPrototypeOf(TintTo)).call(this));
	
	    _this.time = time * 1000;
	    _this.tint = tint;
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(TintTo, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var tint = sprite.tint;
	      var speed = (this.tint - tint) / this._time * deltaMS;
	
	      sprite.tint += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.tint = this.tint;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);
	
	  return TintTo;
	}(_Action4.default);
	
	var TintBy = exports.TintBy = function (_Action2) {
	  _inherits(TintBy, _Action2);
	
	  function TintBy(tint, time) {
	    _classCallCheck(this, TintBy);
	
	    var _this2 = _possibleConstructorReturn(this, (TintBy.__proto__ || Object.getPrototypeOf(TintBy)).call(this));
	
	    _this2.time = time * 1000;
	    _this2.tint = tint;
	
	    _this2.reset();
	    return _this2;
	  }
	
	  _createClass(TintBy, [{
	    key: 'reset',
	    value: function reset() {
	      this._time = this.time;
	      this.ttint = null;
	    }
	    // if end return true, if not end return false
	
	  }, {
	    key: 'update',
	    value: function update(sprite, delta, deltaMS) {
	      var tint = sprite.tint;
	      if (this.ttint === null) {
	        this.ttint = tint + this.tint;
	      }
	
	      var speed = (this.ttint - tint) / this._time * deltaMS;
	
	      sprite.tint += speed;
	
	      this._time -= deltaMS;
	      // return true / false: ended / not end
	      if (this._time <= 0) {
	        sprite.tint = this.ttint;
	        this.reset();
	        return true;
	      }
	      return false;
	    }
	  }]);

	  return TintBy;
	}(_Action4.default);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pixi = __webpack_require__(2);
	
	var PIXI = _interopRequireWildcard(_pixi);
	
	var _ActionManager = __webpack_require__(8);
	
	var _ActionManager2 = _interopRequireDefault(_ActionManager);
	
	var _ActionMove = __webpack_require__(9);
	
	var _ActionScale = __webpack_require__(13);
	
	var _ActionRotate = __webpack_require__(12);
	
	var _ActionFade = __webpack_require__(7);
	
	var _ActionSkew = __webpack_require__(15);
	
	var _ActionPivot = __webpack_require__(10);
	
	var _ActionBlink = __webpack_require__(4);
	
	var _ActionTint = __webpack_require__(17);
	
	var _ActionAlpha = __webpack_require__(3);
	
	var _ActionRepeat = __webpack_require__(11);
	
	var _ActionSequence = __webpack_require__(14);
	
	var _ActionSpawn = __webpack_require__(16);
	
	var _ActionDelay = __webpack_require__(6);
	
	var _ActionCallFunc = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var action = {
	  ActionManager: _ActionManager2.default,
	  MoveTo: _ActionMove.MoveTo,
	  MoveBy: _ActionMove.MoveBy,
	  ScaleTo: _ActionScale.ScaleTo,
	  ScaleBy: _ActionScale.ScaleBy,
	  RotateTo: _ActionRotate.RotateTo,
	  RotateBy: _ActionRotate.RotateBy,
	  FadeIn: _ActionFade.FadeIn,
	  FadeOut: _ActionFade.FadeOut,
	  SkewTo: _ActionSkew.SkewTo,
	  SkewBy: _ActionSkew.SkewBy,
	  PivotTo: _ActionPivot.PivotTo,
	  PivotBy: _ActionPivot.PivotBy,
	  Blink: _ActionBlink.Blink,
	  TintTo: _ActionTint.TintTo,
	  TintBy: _ActionTint.TintBy,
	  AlphaTo: _ActionAlpha.AlphaTo,
	  AlphaBy: _ActionAlpha.AlphaBy,
	  Repeat: _ActionRepeat.Repeat,
	  Sequence: _ActionSequence.Sequence,
	  Spawn: _ActionSpawn.Spawn,
	  DelayTime: _ActionDelay.DelayTime,
	  CallFunc: _ActionCallFunc.CallFunc
	};
	
	if (!PIXI.actionManager) {
	  PIXI.actionManager = new _ActionManager2.default();
	  PIXI.action = action;
	}
	exports.default = action;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build/pixi-action.js